import { typography as variants } from '../../tokens/typography';

export const typography = {
  fontFaces: {},
  global: {},
  variants,
};
